/**
 * All Socket.IO event names used between the Addata client and server.
 * Keep in sync with the backend copy in addata/src/game/socketEvents.ts.
 */
export enum SocketEvent {
  // ── Client → Server ─────────────────────────────────────────────────────
  Init           = "init",
  CreateRoom     = "createRoom",
  JoinRoom       = "joinRoom",
  ShuffleTeams   = "shuffleTeams",
  SwapPlayers    = "swapPlayers",
  ConfirmStart   = "confirmStart",
  Bid            = "bid",
  ChallengeResponse = "challengeResponse",
  PickTrump      = "pickTrump",
  PlayCard       = "playCard",
  PlayAgain      = "playAgain",
  TrailingShuffleDeckTap = "trailingShuffleDeckTap",
  ForfeitMatch   = "forfeitMatch",
  TrumpAcknowledge = "trumpAcknowledge",
  LeaveRoom      = "leaveRoom",
  UpdateRoomCapacity = "updateRoomCapacity",
  AddBotsLobby   = "addBotsLobby",
  RemoveBotsLobby = "removeBotsLobby",
  AddBotDisconnected = "addBotDisconnected",
  HostKickPlayer   = "hostKickPlayer",
  EndSession       = "endSession",

  // ── Server → Client ─────────────────────────────────────────────────────
  AvailableGames    = "availableGames",
  RoomID            = "roomID",
  JoinRoomSuccess   = "joinRoomSuccess",
  PlayerJoined      = "playerJoined",
  Error             = "error",
  LobbyReady        = "lobbyReady",
  TeamsUpdated      = "teamsUpdated",
  StartGame         = "startGame",
  CardsDealt        = "cardsDealt",
  BiddingStart      = "biddingStart",
  BiddingUpdate     = "biddingUpdate",
  ChallengeUpdate   = "challengeUpdate",
  TrumpPickRequired = "trumpPickRequired",
  TrumpPicked       = "trumpPicked",
  TurnStart         = "turnStart",
  CardPlayed        = "cardPlayed",
  RoundComplete     = "roundComplete",
  GameOver          = "gameOver",
  MatchDealIntroState = "matchDealIntroState",
  MatchState        = "matchState",
  ReconnectSuccess  = "reconnectSuccess",
  ReconnectFailed   = "reconnectFailed",
  GameSnapshot      = "gameSnapshot",
  PlayerDisconnected = "playerDisconnected",
  PlayerReconnected  = "playerReconnected",
  LeftRoom           = "leftRoom",
  KickedFromRoom     = "kickedFromRoom",
  SessionEnded       = "sessionEnded",

  // ── Reactions (bidirectional) ──────────────────────────────────────────
  SendReaction        = "sendReaction",
  ReceiveReaction     = "receiveReaction",
  ReactionAnnounce    = "reactionAnnounce",
  ReactionRateLimited = "reactionRateLimited",

  // ── Table GIPHY (all game namespaces) ───────────────────────────────────
  ShareTableGiphy       = "shareTableGiphy",
  TableGiphyPlayed      = "tableGiphyPlayed",
  TableGiphyRateLimited = "tableGiphyRateLimited",

  // ── Literature (namespace /literature only) ────────────────────────────
  LiteratureAsk       = "literatureAsk",
  LiteratureDeclare   = "literatureDeclare",
  LiteratureState     = "literatureState",
  LiteratureGameOver  = "literatureGameOver",

  // ── Rummy (namespace /rummy only) ──────────────────────────────────────
  RummyDraw       = "rummyDraw",
  RummyLayMelds   = "rummyLayMelds",
  RummyDiscard    = "rummyDiscard",
  RummyState      = "rummyState",
  RummyRoundOver  = "rummyRoundOver",
}
